/*
==============================================================================
Rendelwerk Framework
Datei: rw-core.js
Version: 6.7.0

Verantwortung
- Initialisierung
- Sichtbarkeitsregeln
- Aktivieren / Deaktivieren bedingter Felder
- Pflichtfeldvalidierung
- Zeichenzähler
- Automatisch wachsende Textfelder
- Varianten-Erkennung
- Keine Produktlogik
==============================================================================
*/


window.RW = {


    /*
    ==========================================================================
    INITIALISIERUNG
    ==========================================================================
    */

    init() {

        this.cache();
        this.bind();
        this.visibility();
        this.autoGrowTextareas();

    },



    /*
    ==========================================================================
    FELDER LADEN
    ==========================================================================
    */

    cache() {

        this.fields =
            document.querySelectorAll(
                '.rw-field'
            );

    },



    /*
    ==========================================================================
    EVENTS
    ==========================================================================
    */

    bind() {


        /*
        Eingabe:
        - Textarea automatisch vergrößern
        - Zeichenzähler aktualisieren
        */

        document.addEventListener(
            'input',
            (event) => {


                const input =
                    event.target;


                if (
                    !input.matches(
                        '.rw-field input, .rw-field textarea'
                    )
                ) {
                    return;
                }


                const wrapper =
                    input.closest(
                        '.rw-field'
                    );


                if (!wrapper) {
                    return;
                }


                /*
                Automatisch wachsende Textarea
                */

                if (
                    input.matches(
                        'textarea.rw-textarea'
                    )
                ) {

                    this.resizeTextarea(
                        input
                    );

                }


                /*
                Zeichenzähler
                */

                const counter =
                    wrapper.querySelector(
                        '.rw-current-count'
                    );


                if (!counter) {
                    return;
                }


                counter.textContent =
                    input.value.length;


            }
        );




        /*
        Variantenwechsel
        */

        document.addEventListener(
            'change',
            () => {


                setTimeout(
                    () => {

                        this.visibility();

                    },
                    100
                );


            }
        );




        /*
        Shopify Dawn Varianten-Buttons
        */

        document.addEventListener(
            'click',
            () => {


                setTimeout(
                    () => {

                        this.visibility();

                    },
                    150
                );


            }
        );




        /*
        Shopify Variant Event
        */

        document.addEventListener(
            'variant:change',
            () => {

                this.visibility();

            }
        );




        /*
        Warenkorb-Validierung
        */

        document.addEventListener(
            'click',
            (event) => {


                const button =
                    event.target.closest(
                        '[type="submit"], .product-form__submit'
                    );


                if (!button) {
                    return;
                }


                const form =
                    button.closest(
                        'form'
                    );


                if (!form) {
                    return;
                }


                if (!this.validate(form)) {


                    event.preventDefault();

                    event.stopImmediatePropagation();

                    return false;


                }


            },
            true
        );


    },



    /*
    ==========================================================================
    TEXTAREAS AUTOMATISCH VERGRÖSSERN
    ==========================================================================
    */

    autoGrowTextareas() {

        const textareas =
            document.querySelectorAll(
                'textarea.rw-textarea'
            );


        textareas.forEach(
            textarea => {

                this.resizeTextarea(
                    textarea
                );

            }
        );

    },



    /*
    ==========================================================================
    EINZELNE TEXTAREA AN INHALT ANPASSEN
    ==========================================================================
    */

    resizeTextarea(textarea) {

        if (!textarea) {
            return;
        }


        /*
        Höhe zuerst zurücksetzen.
        Dadurch kann das Feld auch wieder kleiner werden,
        wenn Text gelöscht wird.
        */

        textarea.style.height =
            'auto';


        /*
        Neue Höhe anhand des tatsächlichen Inhalts setzen.
        Die CSS-Minimalhöhe bleibt dabei erhalten.
        */

        textarea.style.height =
            `${textarea.scrollHeight}px`;

    },



    /*
    ==========================================================================
    PFLICHTFELDER PRÜFEN
    ==========================================================================
    */

    validate(form) {


        const requiredFields =
            form.querySelectorAll(
                '.rw-field input[required], ' +
                '.rw-field textarea[required], ' +
                '.rw-field select[required]'
            );


        let firstInvalid = null;



        requiredFields.forEach(field => {


            const wrapper =
                field.closest(
                    '.rw-field'
                );


            if (!wrapper) {
                return;
            }



            const error =
                wrapper.querySelector(
                    '.rw-error'
                );



            /*
            Unsichtbare oder deaktivierte Felder
            niemals validieren
            */

            if (
                wrapper.hidden ||
                field.disabled
            ) {


                field.classList.remove(
                    'rw-invalid'
                );


                if (error) {

                    error.hidden = true;

                }


                return;

            }



            /*
            Prüfen ob Feld leer ist
            */

            let isEmpty = false;



            if (
                field.type === 'checkbox' ||
                field.type === 'radio'
            ) {

                isEmpty =
                    !field.checked;

            }

            else if (
                field.type === 'file'
            ) {

                isEmpty =
                    field.files.length === 0;

            }

            else {

                isEmpty =
                    !field.value.trim();

            }



            /*
            Fehler setzen
            */

            if (isEmpty) {


                field.classList.add(
                    'rw-invalid'
                );


                if (error) {

                    error.hidden = false;

                }


                if (!firstInvalid) {

                    firstInvalid = field;

                }


            }

            else {


                field.classList.remove(
                    'rw-invalid'
                );


                if (error) {

                    error.hidden = true;

                }


            }


        });



        if (firstInvalid) {

            firstInvalid.focus();

            return false;

        }



        return true;


    },



    /*
    ==========================================================================
    SHOPIFY-VARIANTEN AUSLESEN

    Unterstützt:
    - Radio
    - Select
    - Dawn Button Varianten
    ==========================================================================
    */

    getSelectedOptions() {


        const values = {};



        /*
        Radio und Select
        */

        const inputs =
            document.querySelectorAll(
                'input[type="radio"]:checked, select'
            );



        inputs.forEach(input => {


            if (!input.name) {
                return;
            }


            values[input.name] =
                input.value;


        });



        /*
        Dawn Varianten-Buttons
        */

        const buttons =
            document.querySelectorAll(
                '.product-form__input button[aria-pressed="true"], ' +
                '.variant-picker button[aria-pressed="true"]'
            );



        buttons.forEach(button => {


            const container =
                button.closest(
                    '.product-form__input, .variant-picker__option'
                );


            if (!container) {
                return;
            }



            const label =
                container.querySelector(
                    'legend, .form__label, label'
                );


            if (!label) {
                return;
            }


            values[
                label.innerText.trim()
            ] =
                button.innerText.trim();


        });



        return values;


    },



    /*
    ==========================================================================
    REGEL PRÜFEN

    Beispiel:
    Gravurart=Beidseitige Gravur
    ==========================================================================
    */

    checkRule(rule) {


        if (!rule) {

            return true;

        }



        const parts =
            rule.split('=');



        if (
            parts.length !== 2
        ) {

            return true;

        }



        const field =
            parts[0]
            .trim()
            .toLowerCase();



        const expected =
            parts[1]
            .trim()
            .toLowerCase();



        const options =
            this.getSelectedOptions();



        let foundValue = '';



        Object.keys(options)
        .forEach(key => {


            if (
                key
                .toLowerCase()
                .includes(field)
            ) {


                foundValue =
                    options[key]
                    .trim()
                    .toLowerCase();


            }


        });



        return (
            foundValue === expected
        );


    },



    /*
    ==========================================================================
    SICHTBARKEIT SETZEN

    Wichtig:
    Unsichtbare Felder werden zusätzlich deaktiviert.

    Dadurch:
    - keine Pflichtfeldvalidierung
    - keine Übertragung in den Warenkorb
    - keine versteckten Personalisierungen
    ==========================================================================
    */

    setFieldVisibility(wrapper, visible) {


        wrapper.hidden =
            !visible;



        const controls =
            wrapper.querySelectorAll(
                'input, textarea, select'
            );



        controls.forEach(control => {


            control.disabled =
                !visible;


            /*
            Sobald eine Textarea sichtbar wird,
            Höhe erneut berechnen.
            */

            if (
                visible &&
                control.matches(
                    'textarea.rw-textarea'
                )
            ) {

                requestAnimationFrame(
                    () => {

                        this.resizeTextarea(
                            control
                        );

                    }
                );

            }


            /*
            Eventuelle Fehler entfernen,
            sobald ein Feld ausgeblendet wird
            */

            if (!visible) {


                control.classList.remove(
                    'rw-invalid'
                );


                const error =
                    wrapper.querySelector(
                        '.rw-error'
                    );


                if (error) {

                    error.hidden = true;

                }


            }


        });


    },



    /*
    ==========================================================================
    FELDER SICHTBAR / UNSICHTBAR MACHEN
    ==========================================================================
    */

    visibility() {


        this.fields.forEach(field => {


            const rule =
                field.dataset.visibleWhen;



            /*
            Keine Regel:
            Feld ist immer sichtbar und aktiv.
            */

            if (!rule) {


                this.setFieldVisibility(
                    field,
                    true
                );


                return;

            }



            const visible =
                this.checkRule(rule);



            this.setFieldVisibility(
                field,
                visible
            );


        });


    }


};



/*
==============================================================================
START
==============================================================================
*/

document.addEventListener(
    'DOMContentLoaded',
    () => {

        RW.init();

    }
);